import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { ProductTagsState } from '../types'

export const errorSelector = createSelector<ReduxState, ProductTagsState, string | undefined>(
  featureStateSelector,
  state => state.UIState.error
)
